import { render, staticRenderFns } from "./PrivacyPhotoCompact.vue?vue&type=template&id=0a0d7cd7&scoped=true"
import script from "./PrivacyPhotoCompact.vue?vue&type=script&lang=js"
export * from "./PrivacyPhotoCompact.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPhotoCompact.vue?vue&type=style&index=0&id=0a0d7cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0d7cd7",
  null
  
)

export default component.exports